import { bl_fi_stmt_account_template_hdr_RowClass } from '../../../dbschema/bl_fi_stmt_account_template_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class StatementOfAccountTemplateHdrModel extends BaseContainerModel {
  bl_fi_stmt_account_template_hdr: bl_fi_stmt_account_template_hdr_RowClass = new bl_fi_stmt_account_template_hdr_RowClass();
}